import styled from 'styled-components'
import { FlexContainer } from '../../components'

export const Container = styled(FlexContainer)`
   padding: 30px;
   width: 100%;
`
